<template>
  <NormalHeaderLayout :header="$t('disclaimerPage.header')">
    <p>{{ $t('disclaimerPage.p1') }}</p>
    <p>{{ $t('disclaimerPage.p2') }}</p>
    <p>{{ $t('disclaimerPage.p3') }}</p>
    <p>{{ $t('disclaimerPage.p4') }}</p>
  </NormalHeaderLayout>
</template>

<script>
import NormalHeaderLayout from '../components/layout/NormalHeaderLayout.vue';

export default {
  components: {
    NormalHeaderLayout,
  },
};
</script>

<style lang="scss" scoped></style>
